module.exports = __webpack_public_path__ + "img/T913.5db373b2.jpg";